import { useQuery, defineQuery, defineQueryOptions } from '@pinia/colada';
import { featureFlagKeys } from './keys';
import { staleTimes } from '../stale-times';
import { fetchFeatureFlags } from 'src/services/feature-flags';

export const featureFlagsQuery = defineQueryOptions({
  key: featureFlagKeys.all,
  query: fetchFeatureFlags,
  staleTime: staleTimes.medium,
  // Never garbage collect: `defineQuery` keeps hold of this entry for the life
  // of the app, so a collected entry would leave it reading stale flags.
  gcTime: false,
});

export const useFetchFeatureFlagsQuery = defineQuery(() => {
  return useQuery({
    ...featureFlagsQuery,
    // The annual returns store keeps this query in use after logout, so without
    // this a window focus would refetch it with no session and get a 401. Reads
    // the flag directly, as importing the auth store here would be circular.
    enabled: () => localStorage.getItem('logged-in') === 'true',
  });
});
